<template>
  <DBox :id="'cmp-catalog-releases-sidewindow-genres'" :addButton="false" :addLink="false"
    :addLinkLabel="$t('add_new_license')" @add_click="onAddGenres">
    <NTable class="dbox1" id="catalog-releases-related-genres" :config="tableConfig" :headers="Headers" :items="list"
      :showNoItems="true">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <!-- <td v-bind="tdcon('licence_account')">
            <span @click="onLicenceClick(item)" class="ut-link ut-text-accent5">{{ item["licence_account_name"] }}</span>
          </td> -->
          <td v-bind="tdcon('licence_account')">
            <span  @click="onLicenceClick(item,'account')" class="txtov ut-link ut-text-accent5" :title="item['licence_account_name']">
              {{ item["licence_account_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('licensee')">
            <span @click="onLicenceClick(item,'licence')" class="ut-link ut-text-accent5">{{ item["licence_name"] }}</span>
          </td>

          <td v-bind="tdcon('licence_type')">
            <span class="txtov" :title="item['licence_type']">
              {{ item["licence_type"] }}
            </span>
          </td>
          <td v-bind="tdcon('start')">
            <span class="txtov" :title="item['date_start']">
              {{ item["date_start"] }}
            </span>
          </td>
          <td v-bind="tdcon('end')">
            <span class="txtov" :title="item['date_end']">
              {{ item["date_end"] }}
            </span>
          </td>
          <td v-bind="tdcon('items')">
            <span class="txtov" :title="item['items']">
              {{ item["items"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { licenceAccountsListLDTRoutes, licencesListLDTRoutes } from "../../../licensing/router/routes";

export default {
  props: {
    selectedReleaseDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: "",
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function () {
      return[
        createTableHeader("licence_account", { f:1.2}),
        createTableHeader("licence_name"),
        createTableHeader("licence_type"),
        createTableHeader("start", {  }),
        createTableHeader("end", {  }),
        createTableHeader("items", {  }),
      ];
    },

    list: function () {
      return this.selectedReleaseDetails.related_licences || [];
    }
  },
  methods: {
    onTextFieldValueChange: function () { },
    onDropdownChange: function (item, e) {
      console.log("ITEM GENRE ENK", e);
      const payload = {
        name: "genre_relation_rank",
        value: e.value,
        item: item
      };

      this.$emit("change", payload);
    },
    onDateChange: function () { 

      
    },
    onLicenceClick: function (item,name) {

      const ldtRoutes = name==='account'?licenceAccountsListLDTRoutes:licencesListLDTRoutes
      const primaryKey = name==='account'?'licence_account_id':'licence_id'
      
      this.$router.push({
        name: ldtRoutes.names.tab,
        params: {
          [primaryKey]: item[primaryKey],
          tab: "overview"
        }
      });
    },
    deleteGenre: function (item) {
      //    const payload={ genre_id:item.genre_id ,genre_relation_id:item.genre_relation_id }
      //    this.$emit("delete",payload)
      //    console.log("Genres",item)
    },
    onAddGenres: function () {
      //          this.$router.push({
      //     ...this.$route,
      //     query: {
      //       modal: "add_genre",
      //       external_id:this.selectedReleaseDetails.release.release_id
      //     },
      //   });
    }
  }
};
</script>
